<div class="input-container">
  @for (input of selectedFields; track input) {
    <div class="input clearfix">
      <span>{{input.field | inputField}}</span>
      <i class="fa fa-minus-circle" aria-hidden="true" (click)="removeField(input)"></i>
    </div>
  }
</div>

<div class="add-field-container">
  <i class="fa fa-plus-circle" aria-hidden="true"></i>

  <div class="select-container">
    <select [ngStyle]="{'width.px':'210', 'display':'inline'}" class="form-control" (change)="holdField($event.target.value)">
      @for (input of availableFields; track input) {
        <option value="{{input.field}}" [attr.selected]="isSelected(input)">{{input.field | inputField}}</option>
      }
      @if (availableFields.length === 0) {
        <option selected>N/A</option>
      }
    </select>
  </div>

  <button class="btn btn-primary" (click)="selectField(heldField)" [class.inactive]="availableFields && availableFields.length === 0" [disabled]="availableFields && availableFields.length === 0">ADD</button>

</div>